import { Modal } from 'antd-mobile';
import classNames from 'classnames';
import './index.less'
export default class HrModal extends Modal {
    constructor(props) {
        super(props)
    }


    render() {
        // const {

        // } = this.props;
        return (
          <div className="dddddddd">
              123123
          </div>
        );
      }
}